module.exports = __webpack_public_path__ + "static/media/EverydayCreativity.809bb6d1.mp3";